<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form">
      <a-form-model-item label="分类标识">
        <a-select
          mode="multiple"
          v-model="selectedItems"
          placeholder="请选择分类标识"
          :value="selectedItems"
          style="width: 100%"
          @change="handleChange"
        >
          <a-select-option v-for="item in filteredOptions" :key="item.id" :value="item.id">
            {{ item.categoryName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="网点标识">
        <a-input v-model="form.tenantId" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="备注">
        <a-input
          v-model="form.remark"
          placeholder="请输入"
          :maxLength="20"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'

import { getObj, addObj, fetchList2 } from '@/api/maintenance/catetoryPoins/index'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      filteredOptions: [],
      formTitle: '',
      selectedItems: [],
      // 表单参数
      form: {
        ids: [],
        remark: undefined,
        tenantId: undefined,
      },
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
    // filteredOptions() {
    //   return this.filteredOptions.filter(o => !this.selectedItems.includes(o));
    // },
  },
  watch: {},
  methods: {
    onClose() {
      this.open = false
    },

    // filterOption(input, option) {
    //   return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    // },
    handleChange(selectedItems) {
      this.form.ids = selectedItems
    },
    // 取消按钮
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    // 表单重置
    reset() {
      this.form = {
        ids: [],
        remark: undefined,
        tenantId: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.getCatetory()
      this.open = true
      this.formTitle = '添加租户网点'
    },
    getCatetory() {
      fetchList2().then((response) => {
        this.filteredOptions = response.data.records
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改热门搜索'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
